export enum AccountType {
    GOVERNMENT = 'GOVERNMENT',
    BUSINESS = 'BUSINESS',
    CONTRACTOR = 'CONTRACTOR',
}
